export default {
  "common": {
    "ok": "確定",
    "language": "語言",
    "languageLoadFailed": "當前語言資源載入失敗，已為你切換到簡體中文",
    "search": "搜 索",
    "reset": "重 置",
    "cancel": "取 消",
    "confirm": "確 定",
    "close": "關 閉",
    "loading": "正在載入中",
    "to": "至",
    "all": "所有",
    "selectAll": "全選",
    "exportExcel": "導出Excel",
    "exportReport": "導出報表",
    "exportDetail": "導出明細表",
    "dateStart": "日期開始",
    "dateEnd": "日期結束",
    "today": "今天",
    "recentPrefix": "最近：",
    "oneMonth": "1個月",
    "finance": "財務",
    "type": "類型",
    "time": "時間",
    "remark": "備註",
    "operator": "操作員",
    "account": "賬號",
    "status": "狀態",
    "amount": "金額",
    "orderNo": "訂單號",
    "selectDate": "請選擇日期",
    "exportProcessing": "文件處理中，請到【下載中心】查看處理結果",
    "paySuccess": "支付成功",
    "payFailed": "支付失敗",
    "income": "收入",
    "expense": "支出",
    "incomeExpenseType": "收支類型",
    "rechargeMethod": "充值方式",
    "serialNo": "流水號",
    "transactionNo": "交易單號",
    "rechargeAccount": "充值賬號",
    "rechargeAmount": "充值金額",
    "passportNo": "護照號",
    "name": "姓名",
    "category": "分類",
    "visaRegion": "簽證地區",
    "visaType": "簽證類型",
    "couponChange": "點券變動",
    "couponBalance": "點券餘額",
    "countryVisaType": "國家/簽證類型",
    "namePassport": "姓名/護照號",
    "couponUnit": "點券",
    "yuan": "元",
    "requestLoading": "正在請求數據",
    "dateRangeTo": "到",
    "operatorStaff": "操作人員",
    "amountWithYuan": "金額(元)",
    "balanceWithYuan": "餘額(元)",
    "inputPlaceholder": "請輸入",
    "confirmModify": "確認修改",
    "enterNumber": "請輸入數字",
    "enterPositiveNumber": "請輸入大於0的數字"
  },
  "nav": {
    "visaTools": "簽證工具",
    "insurance": "保險",
    "visaService": "簽證服務",
    "fliggyOrders": "飛豬訂單",
    "wangdan": "旺單",
    "shanfu": "閃付",
    "overseasTravel": "海外旅遊採購",
    "downloadCenter": "下載中心",
    "accountMgmt": "賬號管理",
    "finance": "財務",
    "freeLogin": "免登",
    "couponAccount": "點券賬戶(簽證工具使用費)",
    "shanfuAccount": "閃付(簽證費代付)",
    "insuranceAccount": "保險賬戶(用於買保險)",
    "recharge": "充值",
    "accountDetail": "賬戶明細",
    "couponUnit": "點券",
    "yuan": "元",
    "bindMobile": "綁定手機號",
    "editPassword": "修改密碼",
    "logout": "退出登入",
    "acquiring": "收單易"
  },
  "platform": {
    "couponAccountLabel": "點券賬戶(簽證工具使用服務費)",
    "mallAccountLabel": "現金賬戶(俄羅斯簽證費)",
    "wangdanIntroAlt": "旺單介紹"
  },
  "financial": {
    "sidebar": {
      "rechargeCenter": "充值中心",
      "couponDetail": "點券明細",
      "mallAccount": "現金賬戶",
      "usa": "美國",
      "malay": "馬來西亞",
      "visaFeeAccount": "簽證費賬戶"
    },
    "breadcrumb": {
      "couponDetail": "點券明細",
      "cashAccount": "現金賬戶",
      "usaAccount": "美國簽證費賬戶",
      "malayAccount": "馬來西亞簽證費賬戶"
    },
    "tabs": {
      "recharge": "充值",
      "expenditure": "支出"
    },
    "payment": {
      "payMethod": "支付方式",
      "scanPay": "掃碼支付",
      "bankTransfer": "銀行轉賬",
      "scanHint": "請使用 支付寶 / 微信 掃碼支付",
      "accountNo": "賬號",
      "accountName": "開戶名",
      "bankName": "開戶行",
      "bankAccountName": "浙江保牛信息科技有限公司",
      "bankBranch": "招商銀行杭州城西支行",
      "rechargeSuccess": "充值成功",
      "continueRecharge": "繼續充值",
      "viewRecords": "查看充值記錄",
      "payable": "應付金額",
      "inputAmount": "請輸入金額",
      "back": "返回",
      "rechargeNow": "立即充值",
      "alipayPay": "支付寶支付",
      "scanToPay": "掃碼付款",
      "cancelPay": "取消付款",
      "confirmPaid": "確認已付款",
      "noScanInfo": "暫無掃碼信息！"
    },
    "recharge": {
      "selectAmountTitle": "請選擇點券充值金額",
      "selectAmountDesc": "點券用於支付使用簽證工具的服務費，充值後無法提現或退款",
      "couponBalance": "點券賬戶餘額",
      "rateHint": "1點券 = 1元",
      "cashInputTitle": "請輸入現金充值金額",
      "cashInputDesc": "現金用於辦簽時使館收取的簽證費用",
      "cashBalance": "現金賬戶餘額",
      "cashAccountDesc": "現金賬戶用於辦簽時使館收取的簽證費用",
      "mallBalanceDesc": "(現金賬戶用於辦簽時使館收取的簽證費用)",
      "couponBalanceLabel": "點券餘額",
      "couponRechargeTitle": "點券充值",
      "offlineNoticePrimary": "暫不支持在線充值，請聯繫與您對接的商務經理充值",
      "offlineNoticeSecondary": "如商務經理無法聯繫，請聯繫客服處理（請在9:00 - 21:00 聯繫）",
      "servicePhone": "客服電話",
      "serviceWechat": "客服微信",
      "servicePhoneNo": "0571-87670963"
    },
    "coupon": {
      "summaryConsume": "共消耗 {n} 點券",
      "summaryRecharge": "共充值 {n} 點券",
      "orderType": "下單類型",
      "summarySeparator": "｜"
    },
    "mall": {
      "balanceTitle": "現金賬戶餘額",
      "rechargeTitle": "現金賬戶充值",
      "accountBalance": "帳戶餘額",
      "rechargeAmountLabel": "充值金額",
      "rechargeAmountRequired": "請輸入充值金額",
      "rechargeAmountPlaceholder": "請輸入您要充值的金額",
      "scanPaySupport": "支持支付寶、微信",
      "notRecharged": "您未充值，請重新掃碼支付",
      "iHaveRecharged": "我已充值",
      "rechargeFailed": "充值失敗，請稍後再試",
      "rechargeCancelled": "充值已取消，請重試",
      "qrcodeAlt": "支付二維碼",
      "amountMustNumber": "充值金額必須為數字",
      "amountMustPositive": "充值金額必須大於0"
    },
    "usa": {
      "cgiNo": "CGI號",
      "receiptNo": "收據號",
      "spendAmount": "支出金額",
      "customerName": "客戶姓名",
      "payTime": "支付時間"
    },
    "malay": {},
    "dialog": {
      "selectRechargeItem": "請選擇充值項",
      "couponFor": "點券可用於：",
      "applyVisa": "辦理簽證",
      "useVisaTool": "使用簽證工具",
      "usaExpedited": "美簽加急預約",
      "accountLabel": "賬號：",
      "lybAccount": "7497 7132 5301",
      "lybAccountName": "深圳市旅雲保科技有限公司",
      "lybBankBranch": "開戶行：中國銀行深圳分行福田支行",
      "defaultAccount": "5719 1190 2610 901",
      "notice1": "1、點券用於支付使用閃電簽平台簽證工具服務的增值服務費",
      "notice2": "2、充值成功即表示閃電簽平台服務已開始",
      "notice3": "3、點券餘額為虛擬幣，充值後無法提現或退款，請確認後再充值",
      "listApplyVisa": "1、辦理簽證",
      "listUseVisaTool": "2、使用簽證工具",
      "listUsaExpedited": "3、美簽加急預約",
      "ticketRecharge": "點券充值",
      "rateResolve": "1元=1點券",
      "rechargeChoice": "充值選擇：",
      "payableAmount": "應付金額：",
      "rechargeMethod": "充值方式：",
      "payNow": "立即支付",
      "alipayOnly": "暫時只支持支付寶支付",
      "visaFeeOnlineRecharge": "簽證費在線充值",
      "step1": "第一步：",
      "step2": "第二步：",
      "step3": "第三步：",
      "alipayScan": "支付寶掃碼",
      "fillRemark": "填寫備註",
      "autoCredit": "自動到賬",
      "alipayScanAlt": "支付寶掃碼",
      "fillRemarkAlt": "填寫備註",
      "autoCreditAlt": "自動到賬",
      "scanPayHint": "點擊下方「掃碼付款」後打開支付寶掃碼支付",
      "remarkHintLyb": "在備註內輸入「旅-充值賬號」即可，為防止誤充或充值失敗，請勿填寫額外內容",
      "remarkHintDefault": "在備註內輸入需充值的賬號即可，為防止誤充或充值失敗，請勿填寫額外內容",
      "remark": "備註",
      "autoCreditHint": "付款成功後點擊「確認已付款」，充值金額將在2小時內自動到賬",
      "accountRechargeTitle": "帳戶充值",
      "accountBalanceLabel": "帳戶餘額：",
      "rechargeAmountColon": "充值金額："
    }
  },
  "message": {
    "list": {
      "title": "消息中心",
      "all": "全部",
      "submitFailure": "提交失敗",
      "unpaidMoney": "待支付領館費用",
      "comeVisa": "出簽",
      "rejectVisa": "拒簽",
      "notification": "消息通知"
    },
    "common": {
      "viewDetail": "查看詳情",
      "noData": "暫無消息"
    },
    "submitFailure": {
      "empty": "暫無待提交失敗消息息",
      "title": "提交失敗消息通知"
    },
    "unpaidMoney": {
      "empty": "暫無待支付領館費用消息",
      "title": "待支付領館費用消息通知"
    },
    "comeVisa": {
      "empty": "暫無出簽消息",
      "title": "出簽消息通知",
      "viewButton": "出簽消息通知"
    },
    "rejectVisa": {
      "empty": "暫無拒簽消息",
      "title": "拒簽消息通知"
    }
  },
  "account": {
    "password": {
      "title": "修改密碼",
      "oldPassword": "原密碼",
      "newPassword": "新密碼",
      "confirmPassword": "確認密碼",
      "oldRequired": "請輸入原密碼",
      "newRequired": "請輸入新密碼",
      "confirmRequired": "請確認密碼",
      "mismatch": "兩次輸入密碼不一致",
      "success": "密碼修改成功",
      "legacyOld": "舊密碼",
      "legacyNew": "新密碼",
      "oldEmpty": "舊密碼不能為空",
      "newEmpty": "新密碼不能為空",
      "patternOld": "請輸入6-16個字符，可以是純數字或者純英文",
      "patternNew": "請輸入8-16位字符，必須是字母加數字的組合",
      "samePassword": "新舊密碼不能相同",
      "modifySuccess": "修改密碼成功"
    }
  }
};
